import React, { useEffect } from 'react';

const XeroSuccess = () => {
  useEffect(() => {
    // This part is "pro": it tells the original window that the popup is done
    if (window.opener) {
      window.opener.postMessage("xero-connected", "*");
    }

    // Automatically close this popup after 5 seconds
    const timer = setTimeout(() => {
      window.close();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'row', // Logo and tick side-by-side
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh', 
      backgroundColor: '#f4f7f6',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ textAlign: 'center', padding: '40px', background: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <img 
          src="https://upload.wikimedia.org/wikipedia/en/9/9f/Xero_software_logo.svg" 
          alt="Xero" 
          style={{ width: '80px', verticalAlign: 'middle' }} 
        />
        <span style={{ fontSize: '50px', marginLeft: '15px', color: '#28a745', verticalAlign: 'middle' }}>
          ✅
        </span>
        <h2 style={{ marginTop: '20px', color: '#333' }}>Connected to Xero!</h2>
        <p style={{ color: '#666' }}>You can close this window or it will close automatically.</p>
      </div>
    </div>
  );
};

export default XeroSuccess;